import { Deferred } from "./deferred";

export class TimeoutFunctionWrapper {
    
    constructor(private outerTimeout: Promise<any>) {
            if (!outerTimeout) {
                throw "outerTimeout required";
        }
    }

    public wrap<TResult>(func: (timeout: Promise<any>) => Promise<TResult>): () => Promise<TResult>;
    public wrap<TArg1, TResult>(func: (timeout: Promise<any>, arg1: TArg1) => Promise<TResult>): (arg1: TArg1) => Promise<TResult>;
    public wrap<TArg1, TArg2, TResult>(func: (timeout: Promise<any>, arg1: TArg1, arg2: TArg2) => Promise<TResult>): (arg1: TArg1, arg2: TArg2) => Promise<TResult>;
    public wrap<TArg1, TArg2, TArg3, TResult>(func: (timeout: Promise<any>, arg1: TArg1, arg2: TArg2, arg3: TArg3) => Promise<TResult>): (arg1: TArg1, arg2: TArg2, arg3: TArg3) => Promise<TResult>;
    public wrap<TArg1, TArg2, TArg3, TArg4, TResult>(func: (timeout: Promise<any>, arg1: TArg1, arg2: TArg2, arg3: TArg3, arg4: TArg4) => Promise<TResult>): (arg1: TArg1, arg2: TArg2, arg3: TArg3, arg4: TArg4) => Promise<TResult> {
            return TimeoutFunctionWrapper.wrap(func as any, this.outerTimeout);
    }


    public static wrap<TResult>(func: (timeout: Promise<any>) => Promise<TResult>, outerTimeout?: Promise<any>): () => Promise<TResult>;
    public static wrap<TArg1, TResult>(func: (timeout: Promise<any>, arg1: TArg1) => Promise<TResult>, outerTimeout?: Promise<any>): (arg1: TArg1) => Promise<TResult>;
    public static wrap<TArg1, TArg2, TResult>(func: (timeout: Promise<any>, arg1: TArg1, arg2: TArg2) => Promise<TResult>, outerTimeout?: Promise<any>): (arg1: TArg1, arg2: TArg2) => Promise<TResult>;
    public static wrap<TArg1, TArg2, TArg3, TResult>(func: (timeout: Promise<any>, arg1: TArg1, arg2: TArg2, arg3: TArg3) => Promise<TResult>, outerTimeout?: Promise<any>): (arg1: TArg1, arg2: TArg2, arg3: TArg3) => Promise<TResult>;
    public static wrap<TArg1, TArg2, TArg3, TArg4, TResult>(func: (timeout: Promise<any>, arg1: TArg1, arg2: TArg2, arg3: TArg3, arg4: TArg4) => Promise<TResult>, outerTimeout?: Promise<any>): (arg1: TArg1, arg2: TArg2, arg3: TArg3, arg4: TArg4) => Promise<TResult> {
    
        function outerFunction() {
                let timeoutDeferred: Deferred;

            function getTimeoutPromise(): Promise<any> {
                    if (timeoutDeferred) {
                        timeoutDeferred.resolve();
                    timeoutDeferred = null;
                }

                timeoutDeferred = new Deferred();

                if (outerTimeout) {
                        outerTimeout.then(() => {
                            timeoutDeferred.resolve();
                    });
                }

                return timeoutDeferred.promise();
            }

            return function (arg1: TArg1, arg2: TArg2, arg3: TArg3,  arg4: TArg4) {
                    const promise = getTimeoutPromise();
                return func(promise, arg1, arg2, arg3, arg4);
            }
        }

        return outerFunction();
    }
}